<table class="utilization-in-period-table" width="100%">
	<thead>
		<tr class="c-text--dark-gray c-text--sm">
			<th scope="col">{{'Hr_Dashboard.Services' | translate}}</th>
			<th scope="col" style="text-align: center;">{{'Hr_Dashboard.Table_Hr_Invitations.Count' | translate}}</th>
		</tr>
	</thead>
	<tbody>
	    <tr>
	        <td colspan="5" class="divider">
	            <hr />
	        </td>
	    </tr>
	    <tr class="c-text--sm">
	        <th scope="row">{{ 'Hr_Dashboard.Therapy_Sessions_Conducted' | translate }}</th>
	        <td>{{vm.getReportSessionDescriptor('COMPLETED')['psychoSessionCount'] || 0}}</td>
	    </tr>
	    <tr class="c-text--sm">
	        <th scope="row">{{ 'Hr_Dashboard.Coaching_Sessions_Conducted' | translate }}</th>
	        <td>{{vm.getReportSessionDescriptor('COMPLETED')['coachSessionCount'] || 0}}</td>
	    </tr>
	    <tr class="c-text--sm">
	        <th scope="row">{{ 'Hr_Dashboard.Audiobooks_Listened' | translate }}</th>
	        <td>{{vm.generatedPreview ? vm.generatedPreview.audiobooksListenedCount || 0 : 0}}</td>
	    </tr>
	    <tr class="c-text--sm">
	        <th scope="row">{{ 'Hr_Dashboard.Mindfulness_App_Downloads' | translate }}</th>
	        <td>{{vm.generatedPreview ? vm.generatedPreview.mindfulnessAppDownloadedCount || 0 : 0}}</td>
	    </tr>
	    <tr class="c-text--sm">
	        <th scope="row">
	        	{{ 'Hr_Dashboard.My_WellBeing_Profiles_Complete' | translate }}
	        	<item-info-popover
	        		itemId="myWellBeingProfilesCompleteInfo"
	        		[text]="'Hr_Dashboard.My_WellBeing_Profiles_Complete_Info' | translate"
	        		title="{{ 'Hr_Dashboard.My_WellBeing_Profiles_Complete_Info' | translate }}"
	        		placement="right"
	        		(click)="$event.preventDefault()"
	        		style="vertical-align: middle;"
	        		class="u-osl-xs">
	        	</item-info-popover>
	        </th>
	        <td>{{vm.generatedPreview ? vm.generatedPreview.myWellBeingProfileCompletedCount || 0 : 0}}</td>
	    </tr>
    </tbody>
</table>
